/* eslint-disable @next/next/no-img-element */
import WrapperLink from '@/components/link/WrapperLink';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useContext, useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import SwiperClass from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import { postReadPost } from '../../../../apis/tms/post.api';
import { setPostVisitorRead } from '../../../../common/post/ultils';
import { PATH_NAME } from '../../../../configs/pathName';
import {
  LockedPostDefaultThumbnail,
  WhiteLockIcon,
} from '../../../../constant/imgImport';
import { PostContext } from '../../../../context/PostContext';
import { useGenericGetLinkThumbnail } from '../../../../hooks/post/useGetLinkThumbnail';
import { EPostType } from '../../../../interfaces/post.interface';
import { FolderStatusEnum } from '../../../../interfaces/training.interface';
import AuthContext from '../../../../state/auth/AuthContext';
import RequestJoinGroupButton from '../../../buttons/training-module/RequestJoinGroupButton';
import {
  PostThumbnail,
  PostThumbnailSkeleton,
} from '../../../modal/training-module/post/components/PostThumbnail';
import BlogBodyUI from './component/BlogBodyUI';
import ImageSwiper from './component/ImageSwiper';
import PostBodyUI from './component/PostBodyUI';

const PostBody = () => {
  const { group, isLocked, ...postInfo } = useContext(PostContext);
  const [swiper, setSwiper] = useState<SwiperClass | null>(null);
  const { isLoggedIn } = useContext(AuthContext);
  const router = useRouter();
  const { pid } = router.query;

  const { ref, inView } = useInView();

  useEffect(() => {
    let time: any;
    if (inView) {
      time = setTimeout(async () => {
        isLoggedIn()
          ? await postReadPost(postInfo.postId)
          : setPostVisitorRead(postInfo.postId);
      }, 3000);
    }
    return () => {
      if (!inView) {
        clearTimeout(time);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  useEffect(() => {
    if (swiper) {
      swiper?.pagination?.destroy();
      swiper?.pagination?.init();
      swiper?.pagination?.bullets[0]?.classList.add(
        'swiper-pagination-bullet-active'
      );
      if (postInfo.images.length > 6) {
        swiper?.pagination?.el?.classList.add(
          'swiper-pagination-bullets-dynamic'
        );
      } else {
        const pagination: HTMLElement = swiper?.pagination?.el;
        pagination?.classList.remove('swiper-pagination-bullets-dynamic');
        pagination?.style?.setProperty('width', '100%');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postInfo.images]);

  const {
    thumbnailInfo,
    urls,
    loading: postThumbnailLoading,
  } = useGenericGetLinkThumbnail(postInfo.content.replace(/<img .*?>/g, '')); //not get url in img

  return (
    <WrapperLink
      href={
        !isLocked && router.pathname !== PATH_NAME.HOME_FEED_POST_DETAIL
          ? {
              pathname: PATH_NAME.HOME_FEED_POST_DETAIL,
              query: {
                pid: postInfo.postId,
              },
            }
          : undefined
      }
      anchorProps={{
        className: 'w-full text-left',
      }}
    >
      {/* thumbnail, display depends on isLocked */}
      {isLocked ? (
        <div className={`relative h-[273px] w-full ${pid && 'xl:h-[500px]'}`}>
          <img
            src={postInfo.images[0] ?? LockedPostDefaultThumbnail}
            alt="locked thumbnail"
            className="h-full w-full overflow-hidden object-cover blur-sm"
          />
          <div className="absolute bottom-0 left-0 top-0 flex h-full w-full items-center justify-center bg-[#000000A6] blur-sm" />
          <div className="absolute bottom-0 left-0 right-0 top-0 flex h-full w-full flex-col items-center justify-center gap-4 text-white">
            <Image
              src={WhiteLockIcon}
              alt="white lock icon"
              width={24}
              height={24}
            />
            <div className="text-center text-sm">
              <p>Nội dung được bảo vệ riêng tư.</p>
              <p>Tham gia nhóm để hiển thị.</p>
            </div>
            {group && (
              <div>
                <RequestJoinGroupButton
                  initContent={'Tham gia nhóm'}
                  undoContent={'Hủy yêu cầu'}
                  groupId={group.groupId}
                  groupPrivacyStatus={FolderStatusEnum.Private}
                  className="!h-full !w-full !flex-1 !rounded-md !px-[22.5px] !py-[10px] !text-sm !font-semibold !leading-[16px] !tracking-[-0.1px] !shadow-none"
                  variant={'contained'}
                  containerClassname="w-full md:w-auto"
                  size="h-10 w-30"
                />
              </div>
            )}
          </div>
        </div>
      ) : pid && postInfo.type === EPostType.Blog ? null : postInfo.images
          .length > 0 ? (
        <ImageSwiper
          setSwiper={setSwiper}
          images={
            postInfo.type === EPostType.Post
              ? postInfo.images
              : postInfo.images.slice(0, 1)
          }
        />
      ) : postThumbnailLoading ? (
        <PostThumbnailSkeleton />
      ) : thumbnailInfo.thumbnailUrl ? (
        <PostThumbnail
          title={thumbnailInfo.title}
          domain={thumbnailInfo.domain}
          url={thumbnailInfo.thumbnailUrl}
          websiteUrl={urls ? urls[0] : ''}
        />
      ) : null}
      <div ref={ref}></div>
      <div className={`pb-2`}>
        {postInfo.type === EPostType.Blog ? <BlogBodyUI /> : <PostBodyUI />}
      </div>
    </WrapperLink>
  );
};

export default PostBody;
